import { render, staticRenderFns } from "./FieldBox.vue?vue&type=template&id=556751ca&scoped=true&"
import script from "./FieldBox.vue?vue&type=script&lang=js&"
export * from "./FieldBox.vue?vue&type=script&lang=js&"
import style0 from "./FieldBox.vue?vue&type=style&index=0&id=556751ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556751ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('556751ca')) {
      api.createRecord('556751ca', component.options)
    } else {
      api.reload('556751ca', component.options)
    }
    module.hot.accept("./FieldBox.vue?vue&type=template&id=556751ca&scoped=true&", function () {
      api.rerender('556751ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/pdf/formBuilder/components/FieldBox.vue"
export default component.exports